<mat-card appearance="outlined">
  <mat-card-title style="font-size:x-large;margin-bottom:25px"><span class="form-control">{{raisonSociale}}</span><br/></mat-card-title>
  <mat-card-title>M'abonner au prélèvement</mat-card-title>
  <form [formGroup]="formGroup">
    <div class="field">
      <mat-form-field appearance="fill">
        <mat-label>Mobile</mat-label>
        <mat-select #telephoneSingleSelect [(ngModel)]="mandatCreate.telephone"
          [formControl]="$any(formGroup).controls['telephones']"
          placeholder="Mobile" required>
          <mat-option>
            <ngx-mat-select-search [formControl]="telephoneFilterCtrl" noEntriesFoundLabel="Aucun mobile trouvé"
              placeholderLabel="Rechercher un mobile">
            </ngx-mat-select-search>
          </mat-option>
          @for (telephone of filteredTelephones | async; track telephone) {
            <mat-option [value]="telephone">
              {{telephone}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <button (click)="openDialogTelephone()" class="green-button" mat-mini-fab>
        <mat-icon>add</mat-icon>
      </button>
      <div class="mat-hint">
        Cliquer sur « + » pour ajouter un numéro de mobile.<br>
        Le téléphone portable servira à confirmer la signature du mandat de prélèvement, par envoi d'un SMS.
      </div>
    </div>
    <div class="field field-ej">
      <mat-form-field appearance="fill">
        <mat-label>Fournisseur In Extenso</mat-label>
        <mat-select #ejSingleSelect [(ngModel)]="mandatCreate.ej" [formControl]="$any(formGroup).controls['ejs']" placeholder="EJ"
          required>
          <mat-option>
            <ngx-mat-select-search [formControl]="ejFilterCtrl" noEntriesFoundLabel="Aucun fournisseur trouvé"
              placeholderLabel="Rechercher un fournisseur">
            </ngx-mat-select-search>
          </mat-option>
          @for (ej of filteredEjs | async; track ej) {
            <mat-option [value]="ej.codeEj">
              {{ej.libelle}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="field">
      <mat-form-field appearance="fill">
        <mat-label>IBAN</mat-label>
        <mat-select #ibanSingleSelect [(ngModel)]="mandatCreate.iban" [formControl]="$any(formGroup).controls['ibans']"
          placeholder="IBAN" required>
          <mat-option>
            <ngx-mat-select-search [formControl]="ibanFilterCtrl" noEntriesFoundLabel="Aucun IBAN trouvé"
              placeholderLabel="Rechercher un IBAN">
            </ngx-mat-select-search>
          </mat-option>
          @for (iban of filteredIbans | async; track iban) {
            <mat-option [value]="iban.codeIban">
              {{iban.codeIban}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <button (click)="openDialogIban()" class="green-button" mat-mini-fab>
        <mat-icon>add</mat-icon>
      </button>
      <div class="mat-hint">
        Cliquer sur « + » pour ajouter un IBAN.<br>
      </div>
    </div>
    <div class="actions">
      <button [disabled]="formGroup.invalid" class="green-button" mat-button type="submit" (click)="onSubmit()">Valider</button>
    </div>
  </form>

  @if (isLoading) {
    <div class="spinner-form">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
  }

  @if (isLoadingMandat) {
    <div class="spinner-form">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
  }
</mat-card>
